import { render, staticRenderFns } from "./BaseRankingList.vue?vue&type=template&id=2edbdfc8&scoped=true&"
import script from "./BaseRankingList.vue?vue&type=script&lang=js&"
export * from "./BaseRankingList.vue?vue&type=script&lang=js&"
import style0 from "./BaseRankingList.vue?vue&type=style&index=0&id=2edbdfc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbdfc8",
  null
  
)

export default component.exports